export default __webpack_public_path__ + "static/media/Relax.592909ae.jpg";